<div class="page-header">
  <div>
    <h1 class="page-title">Settings</h1>
    <p class="page-subtitle">Configure application preferences and system settings</p>
  </div>
  <div class="page-header-actions">
    <button class="btn btn-primary">Save Changes</button>
  </div>
</div>

<div class="data-card">
  <div class="data-card-header">
    <div>
      <span class="data-card-title">System Configuration</span>
      <span class="data-count">{{ settings.length }} settings</span>
    </div>
    <div class="data-card-meta">
      <input type="text" placeholder="Search settings..." style="width:220px">
    </div>
  </div>

  <table>
    <thead>
      <tr>
        <th>#</th>
        <th>Setting</th>
        <th>Value</th>
        <th>Category</th>
        <th>Status</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of settings">
        <td>{{ row.id }}</td>
        <td>{{ row.key }}</td>
        <td>{{ row.value }}</td>
        <td>{{ row.category }}</td>
        <td><span class="status-badge status-badge--{{ row.status }}">{{ row.status }}</span></td>
        <td>
          <div class="action-btns">
            <button class="btn-icon" title="Edit">
              <svg width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
            </button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
